module.exports = __webpack_public_path__ + "img/podcast-logo.9e70ac18.jpg";